export default {
    getFinishOrder: { method: 'get', url: 'sale/getOrders/?user={id}' }
  }